import { CheckboxGroupInput, Datagrid, Filter, TextField, TextInput } from 'react-admin'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import {
  CustomLoadSearchVisibilityChoices,
  LABEL_DROPOFF_DATE,
  LABEL_ORIGIN_TO_DESTINATION,
  LABEL_PICKUP_DATE,
} from '../../helpers/constants'
import { CustomBooleanField, CustomDateField, CustomLoadOriginDestinationField } from '../Fields'
import CTList from '../List'

const PST_TZ = ' (PST)'

const CustomLoadFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <CheckboxGroupInput
      label="Visibility in Search"
      source="show_in_search"
      choices={CustomLoadSearchVisibilityChoices}
      alwaysOn
    />
  </Filter>
)

const CustomLoadsList = (props: any) => {
  usePageTitle('Custom Loads')
  return (
    <CTList
      bulkActionButtons={false}
      filters={<CustomLoadFilter />}
      filterDefaultValues={{ show_in_search: ['True'] }}
      title="Custom Loads"
      {...props}
    >
      <Datagrid optimized rowClick="show">
        <TextField source="external_source" label="Source" />
        <TextField source="external_source_human_id" label="Broker load ID" />
        <TextField source="broker.name" label="Broker" />
        <CustomLoadOriginDestinationField label={LABEL_ORIGIN_TO_DESTINATION} />
        <CustomDateField source="origin_pickup_date" label={LABEL_PICKUP_DATE + PST_TZ} />
        <CustomDateField source="dest_delivery_date" label={LABEL_DROPOFF_DATE + PST_TZ} />
        <CustomBooleanField source="show_in_search" label="Shown in Search" />
        <TextField source="id" />
      </Datagrid>
    </CTList>
  )
}

export default CustomLoadsList
